import React from "react";
import { translate } from "@td/shared_utils";
import { ActionButton, PlusIcon } from "@td/ui";

const CreateTaskButton = React.memo((props) => (
  <ActionButton
    {...props}
    icon={PlusIcon}
    label={translate(null, "care_team_tasks", "create_task_button")}
  />
));

export default CreateTaskButton;
